import { c as _c } from "react/compiler-runtime";
import { useIntl } from '@onefootprint/hooks';
import { useTranslation } from 'react-i18next';
import getDocumentStatus from '@/entity/components/content/components/document-item/utils/get-document-status';
import useDocumentText from '@/entity/hooks/use-document-text';
import type { TransformedDocument } from '@/entity/hooks/use-documents';
const SIDE_ORDER = ['front', 'back', 'selfie'] as const;
const useDocumentSummary = document => {
  const $0 = _c(34);
  let t0;
  if ($0[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "onboardings.documents"
    };
    $0[0] = t0;
  } else {
    t0 = $0[0];
  }
  const {
    t
  } = useTranslation("entity-details", t0);
  let t1;
  if ($0[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "fieldset.documents"
    };
    $0[1] = t1;
  } else {
    t1 = $0[1];
  }
  const {
    t: documentsT
  } = useTranslation("entity-details", t1);
  const {
    formatDateWithTime
  } = useIntl();
  const getDocumentText = useDocumentText();
  let t2;
  if ($0[2] !== document) {
    t2 = getDocumentStatus(document);
    $0[2] = document;
    $0[3] = t2;
  } else {
    t2 = $0[3];
  }
  const status = t2;
  let t3;
  if ($0[4] !== document.kind || $0[5] !== document.uploads || $0[6] !== getDocumentText) {
    t3 = document.kind === "custom" ? document.uploads[0]?.identifier ?? "" : getDocumentText(document.kind);
    $0[4] = document.kind;
    $0[5] = document.uploads;
    $0[6] = getDocumentText;
    $0[7] = t3;
  } else {
    t3 = $0[7];
  }
  const title = t3;
  let t4;
  let t5;
  if ($0[8] !== document.startedAt || $0[9] !== document.uploads || $0[10] !== formatDateWithTime || $0[11] !== t) {
    let t6;
    if ($0[14] !== document.uploads) {
      t6 = side => document.uploads.some(upload => upload.isLatest && upload.side === side);
      $0[14] = document.uploads;
      $0[15] = t6;
    } else {
      t6 = $0[15];
    }
    const sides = SIDE_ORDER.filter(t6);
    if ($0[16] !== document.startedAt || $0[17] !== formatDateWithTime) {
      t4 = document.startedAt && formatDateWithTime(new Date(document.startedAt), {
        month: "short",
        year: "numeric"
      });
      $0[16] = document.startedAt;
      $0[17] = formatDateWithTime;
      $0[18] = t4;
    } else {
      t4 = $0[18];
    }
    t5 = sides.length > 0 && sides.map(side_0 => t($ => $.sides[side_0])).join(", ");
    $0[8] = document.startedAt;
    $0[9] = document.uploads;
    $0[10] = formatDateWithTime;
    $0[11] = t;
    $0[12] = t4;
    $0[13] = t5;
  } else {
    t4 = $0[12];
    t5 = $0[13];
  }
  let t6;
  if ($0[19] !== document.redactedAt || $0[20] !== documentsT) {
    t6 = document.redactedAt && documentsT(_temp);
    $0[19] = document.redactedAt;
    $0[20] = documentsT;
    $0[21] = t6;
  } else {
    t6 = $0[21];
  }
  let t7;
  if ($0[22] !== t4 || $0[23] !== t5 || $0[24] !== t6) {
    t7 = [t4, t5, t6].filter(Boolean);
    $0[22] = t4;
    $0[23] = t5;
    $0[24] = t6;
    $0[25] = t7;
  } else {
    t7 = $0[25];
  }
  const details = t7;
  let t8;
  if ($0[26] !== documentsT || $0[27] !== status) {
    t8 = status ? documentsT($_1 => $_1.status[status]) : undefined;
    $0[26] = documentsT;
    $0[27] = status;
    $0[28] = t8;
  } else {
    t8 = $0[28];
  }
  let t9;
  if ($0[29] !== details || $0[30] !== status || $0[31] !== t8 || $0[32] !== title) {
    t9 = {
      title,
      details,
      status,
      statusText: t8
    };
    $0[29] = details;
    $0[30] = status;
    $0[31] = t8;
    $0[32] = title;
    $0[33] = t9;
  } else {
    t9 = $0[33];
  }
  return t9;
};
export default useDocumentSummary;
function _temp($_0) {
  return $_0.imagesRedacted;
}